var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopularPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4152_28945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 15.5C33 16.7755 32.8294 17.966 32.4881 19.0714C31.2082 23.4082 27.6246 26.7245 23.1024 27.7449C22.2491 27.915 21.3959 28 20.4573 28C13.6314 28 8 22.3878 8 15.5C8 8.61225 13.6314 3 20.5427 3C27.4539 3 33 8.61225 33 15.5Z",
    fill: "url(#paint0_linear_4152_28945)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2471 18.5613L27.3078 14.097L25.9608 18.5613L23.2667 21.6863L17.8784 22.1327L23.2667 26.597L32.2471 18.5613Z",
    fill: "url(#paint1_linear_4152_28945)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5725 23.0255C24.5403 23.0255 27.7568 19.8276 27.7568 15.8827C27.7568 11.9378 24.5403 8.73984 20.5725 8.73984C16.6047 8.73984 13.3882 11.9378 13.3882 15.8827C13.3882 19.8276 16.6047 23.0255 20.5725 23.0255ZM19.0757 14.0224C19.0757 14.6388 18.5731 15.1385 17.9531 15.1385C17.3331 15.1385 16.8306 14.6388 16.8306 14.0224C16.8306 13.406 17.3331 12.9064 17.9531 12.9064C18.5731 12.9064 19.0757 13.406 19.0757 14.0224ZM24.3144 14.0224C24.3144 14.6388 23.8118 15.1385 23.1918 15.1385C22.5719 15.1385 22.0693 14.6388 22.0693 14.0224C22.0693 13.406 22.5719 12.9064 23.1918 12.9064C23.8118 12.9064 24.3144 13.406 24.3144 14.0224ZM16.9804 17.6684C17.5641 19.4095 19.0159 20.6446 20.7222 20.6446C22.4285 20.6446 23.8803 19.4095 24.464 17.6684H16.9804Z",
    fill: "url(#paint2_linear_4152_28945)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4152_28945",
    x: 0,
    y: 0,
    width: 41,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.1125 0 0 0 0 0.295916 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4152_28945"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4152_28945",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4152_28945",
    x1: 8,
    y1: 15.5135,
    x2: 33.0341,
    y2: 15.5135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4152_28945",
    x1: 22.2387,
    y1: 17.7925,
    x2: 27.9359,
    y2: 24.1132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F6AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#657EFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4152_28945",
    x1: 25.9167,
    y1: 21.1486,
    x2: 17.6048,
    y2: 12.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0113208,
    stopColor: "#C2D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopularPost);
export default __webpack_public_path__ + "static/media/popularPost.1d536261.svg";
export { ForwardRef as ReactComponent };